import { SiteLink } from '../components/site-link';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../lib/use-page-title';

export function NotFoundPage() {
  const { t } = useTranslation();
  // After client-side navigation to an unknown URL the tab title must say so too.
  usePageTitle('/404', t('notFound.title'));
  return (
    <div className="container page narrow">
      <h1>{t('notFound.title')}</h1>
      <p>{t('notFound.body')}</p>
      <SiteLink className="button button-primary" to="/">
        {t('notFound.home')}
      </SiteLink>
    </div>
  );
}
